import { ApolloError } from "@apollo/client";

import { TFunction, TOptions } from "@kazoohr/internationalization";

import { getTranslationsFromApolloError } from "./getTranslationsFromApolloError";

export function getHookDefaultErrorHandler(
  toastFn: (message: any) => void,
  t: TFunction,
  options: {
    defaultToastErrorMessageOrTranslationKey?: string;
    defaultToastErrorTranslationOptions?: TOptions;
  } = {}
) {
  return (error: ApolloError) => {
    // eslint-disable-next-line no-console
    console.error(error);

    const translations = getTranslationsFromApolloError(error);
    if (translations) {
      for (const [translationKey, translationValues] of translations) {
        toastFn(t(translationKey, translationValues));
      }
      return;
    }

    if (options.defaultToastErrorMessageOrTranslationKey) {
      toastFn(
        t(
          options.defaultToastErrorMessageOrTranslationKey,
          options.defaultToastErrorTranslationOptions
        )
      );
      return;
    }

    toastFn(t("common:errors.somethingWentWrongError"));
  };
}
